import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { modeKeys } from './modeKeys';

export const tenantModeSchema = z.object({
  // "test" | "live" — the tenant's current operating mode.
  mode: z.string(),
  // Whether the Console has production enabled for this company. When false the
  // Test Mode toggle stays locked on (cannot switch to live).
  productionEnabled: z.boolean(),
});

export type TenantMode = z.infer<typeof tenantModeSchema>;

export function useTenantMode() {
  const tenantId = useTenantStore((s) => s.tenantId);

  return useQuery({
    queryKey: modeKeys.detail(tenantId ?? ''),
    enabled: !!tenantId,
    queryFn: async ({ signal }) => {
      const raw = await apiClient.get(`api/v1/t/${tenantId}/mode`, { signal }).json();
      return tenantModeSchema.parse(raw);
    },
    staleTime: 30_000,
  });
}
